import React from 'react';
import { useStore } from '../hooks/useStore';
import { useProducts } from '../hooks/useProducts';
import ProductCard from '../components/ProductCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Package } from 'lucide-react';
import { Link } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function HomePage() {
  const { settings } = useStore();
  const { products, loading } = useProducts();

  const recentProducts = products
    .sort((a, b) => b.createdAt.toMillis() - a.createdAt.toMillis())
    .slice(0, 8);

  const onSaleProducts = products.filter(product => product.salePrice > 0).slice(0, 8);

  return (
    <div className="space-y-12">
      {/* Hero Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-[#0F172A] rounded-lg overflow-hidden">
        <div className="p-8 flex flex-col justify-center">
          <h1 className="text-4xl font-bold text-white mb-4">
            Descubra produtos <br/>
            <span className="text-[#C5D86D]">incríveis hoje</span>
          </h1>
          <p className="text-gray-300 mb-6">
            Encontre os melhores produtos de vendedores verificados com preços incríveis.
          </p>
          <Link
            to="/products"
            className="inline-block bg-[#C5D86D] text-[#0F172A] px-6 py-3 rounded-md font-medium hover:bg-[#b3c561] transition-colors w-fit"
          >
            Começar a comprar
          </Link>
        </div>
        <div className="hidden md:block">
          <img
            src={settings.bannerImage || '/shopping.jpg'}
            alt="Banner"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      {/* Categories */}
      <div>
        <h2 className="text-2xl font-bold mb-6">Categorias</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {settings.categories?.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow text-center"
            >
              <div className="w-12 h-12 bg-[#F8FAFC] rounded-full flex items-center justify-center mb-3">
                <Package className="w-6 h-6 text-[#0F172A]" />
              </div>
              <span className="font-medium text-[#0F172A]">{category.name}</span>
            </Link>
          ))}
        </div>
      </div>

      {/* Products on Sale */}
      {onSaleProducts.length > 0 && (
        <div>
          <h2 className="text-2xl font-bold mb-6">Produtos em Promoção</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {onSaleProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      )}

      {/* Recent Products */}
      {recentProducts.length > 0 && (
        <div>
          <h2 className="text-2xl font-bold mb-6">Produtos Recentes</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {recentProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
